import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { AlertCircle, Bell, Info } from "lucide-react";

export default function AdminAlerts() {
  const [alerts, setAlerts] = useState([]);
  useEffect(() => { api.get("/admin/alerts").then(r => setAlerts(r.data.alerts || [])); }, []);
  const icon = (sev) => sev === "high" ? <AlertCircle className="h-5 w-5 text-destructive"/> : sev === "medium" ? <Bell className="h-5 w-5 text-[hsl(var(--accent))]"/> : <Info className="h-5 w-5 text-muted-foreground"/>;
  return (
    <div data-testid="admin-alerts-page">
      <h1 className="editorial-heading text-4xl">Alerts AI</h1>
      <div className="mt-6 space-y-2">
        {alerts.length === 0 && <div className="text-muted-foreground">Nessun alert</div>}
        {alerts.map((a, i) => (
          <div key={i} data-testid={`alert-${i}`} className="bg-card border border-border rounded-sm p-4 flex items-center gap-3">
            {icon(a.severity)}
            <div className="flex-1">
              <div className="text-[10px] uppercase tracking-wider font-bold text-muted-foreground">{a.type}</div>
              <div className="text-sm">{a.message}</div>
            </div>
            <span className={`chip ${a.severity === "high" ? "bg-destructive text-white" : a.severity === "medium" ? "bg-[hsl(var(--accent))] text-black" : "bg-[hsl(var(--muted))]"}`}>{a.severity}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
